// extracted by mini-css-extract-plugin
export default {"outer":"invisibleScroll--outer--GPfMNmrm","inner":"invisibleScroll--inner--mwTERHs3"};